import axios, { AxiosRequestConfig } from 'axios';

import constants from '../../constants';
import { SimpleFile } from '../../helpers/downloadFile';

export const getManual = async (customerNumber: string, year: string, type: string): Promise<SimpleFile> => {
  const fileName = `${year}_${type}_Manual`
  const baseUrl = `${constants.ONTRAQ_API_URL}/api2`
  const config: AxiosRequestConfig = { responseType: 'blob' }

  const response = await axios.get(`${baseUrl}/osha-hipaa/${customerNumber}/emanuals/${fileName}`, config)
  const url = URL.createObjectURL(response.data)

  return { url, fileName, isBlobURL: true }
}
